import { render } from "./AppInputField.vue?vue&type=template&id=484c6554&scoped=true"
import script from "./AppInputField.vue?vue&type=script&lang=js"
export * from "./AppInputField.vue?vue&type=script&lang=js"

import "./AppInputField.vue?vue&type=style&index=0&id=484c6554&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484c6554"]])

export default __exports__